export const adjustForBigWins = items => items
  .slice(0, 20)
  .map((item, index) => {
    if (index < 4 && item.amountWon < 1000000) {
      item.amountWon += 1000000;// Make it a 7-digit number

      return item;
    }

    if (index >= 4 && index < 10 && item.amountWon < 100000) {
      item.amountWon += 100000; // Make it a 6-digit number

      return item;
    }

    if (index >= 10 && item.amountWon < 10000) {
      item.amountWon += 10000; // Make it a 5-digit number

      return item;
    }

    return item;
  })
  .sort((a, b) => b.amountWon - a.amountWon);
